type ReactEnvName = 'local' | 'production' | 'post-staging' | 'dins-development' | 'dins-development-general' | 'dins-development-series';
type NodeEnvName = 'dins-development' | 'production' | 'test';
type EnvName = ReactEnvName | NodeEnvName;

interface Settings {
  projectRegion: string;
  userPoolId: string;
  clientId: string;
  apiGateway: string;
  portalApi: string;
  portalDomain: string; // MFA対応
  redirectSignIn: string;
  redirectSignOut: string;
  aggridLicenceKey: string;
  cognitoDomain: string;
  handsontableLicenseKey: string; // handsontable ライセンスキー
  hyperformulaLicenseKey: string; // HyperFormula ライセンスキー
  useMockMfaAuth?: boolean; // MFA対応
  googleAnalyticsId: string;
  useGa: boolean;
}
interface EnvSettings {
  local: Settings;
  test: Settings;
  production: Settings;
  'post-staging': Settings;
  'dins-development': Settings;
  'dins-development-general': Settings;
  'dins-development-series': Settings;
}

export const currentEnv: EnvName = process.env.REACT_APP_ENV || process.env.NODE_ENV;

const envSettings: EnvSettings = {
  local: {
    projectRegion: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_lfKgSdiLf',
    clientId: 'r6kpppe6cba74snft7igfn9hl',
    apiGateway: 'http://localhost:3010/backend',
    portalApi: 'http://localhost:13010',
    portalDomain: 'http://localhost:13010', // MFA対応
    redirectSignIn: 'http://localhost:3000',
    redirectSignOut: 'http://localhost:3000',
    cognitoDomain: 'ap-northeast-1lfkgsdilf.auth.ap-northeast-1.amazoncognito.com',
    aggridLicenceKey:
      'Using_this_{AG_Grid}_Enterprise_key_{AG-050661}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Toyotsu_Syscom}_is_granted_a_{Multiple_Applications}_Developer_License_for_{15}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{15_November_2024}____[v3]_[01]_MTczMTYyODgwMDAwMA==c8c0a18b3636f327eee47079f2b25bc0',
    handsontableLicenseKey: '5c519-a234b-b95e5-c423d-4e85b',
    hyperformulaLicenseKey: 'internal-use-in-handsontable',
    googleAnalyticsId: 'G-QWFQV51XX0', //bonsai-local
    useGa: false, // MEMO:googleAnalyticsでエラーになっていたため false にする
    useMockMfaAuth: false, // MFA対応 - trueの場合, MFA設定API(/auth/set-mfa)のresponseはモックデータから取得
  },

  'dins-development': {
    projectRegion: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_lfKgSdiLf',
    clientId: 'r6kpppe6cba74snft7igfn9hl',
    apiGateway: 'https://bonsai-development.datainsight-dev.toyota-tsusho.com/backend',
    portalApi: 'https://portal-devevelopment-server.datainsight-dev.toyota-tsusho.com',
    portalDomain: 'https://portal-devevelopment-server.datainsight-dev.toyota-tsusho.com', // MFA対応
    redirectSignIn: 'https://bonsai-development.datainsight-dev.toyota-tsusho.com',
    redirectSignOut: 'https://bonsai-development.datainsight-dev.toyota-tsusho.com',
    cognitoDomain: 'ap-northeast-1lfkgsdilf.auth.ap-northeast-1.amazoncognito.com',
    // MEMO:以下の外部Componentのライセンス数は問題ない？
    aggridLicenceKey:
      'Using_this_{AG_Grid}_Enterprise_key_{AG-050661}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Toyotsu_Syscom}_is_granted_a_{Multiple_Applications}_Developer_License_for_{15}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{15_November_2024}____[v3]_[01]_MTczMTYyODgwMDAwMA==c8c0a18b3636f327eee47079f2b25bc0',
    handsontableLicenseKey: '5c519-a234b-b95e5-c423d-4e85b',
    hyperformulaLicenseKey: 'internal-use-in-handsontable',
    googleAnalyticsId: 'G-T8QCMXC694', //bonsai-dev
    useGa: true,
    useMockMfaAuth: false, // MFA対応 - trueの場合, MFA設定API(/auth/set-mfa)のresponseはモックデータから取得
  },

  'dins-development-general': {
    projectRegion: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_lfKgSdiLf',
    clientId: 'r6kpppe6cba74snft7igfn9hl',
    apiGateway: 'https://bonsai-development-general.datainsight-dev.toyota-tsusho.com/backend',
    portalApi: 'https://portal-devevelopment-server.datainsight-dev.toyota-tsusho.com',
    portalDomain: 'https://portal-devevelopment-server.datainsight-dev.toyota-tsusho.com', // MFA対応
    redirectSignIn: 'https://bonsai-development-general.datainsight-dev.toyota-tsusho.com',
    redirectSignOut: 'https://bonsai-development-general.datainsight-dev.toyota-tsusho.com',
    cognitoDomain: 'ap-northeast-1lfkgsdilf.auth.ap-northeast-1.amazoncognito.com',
    // MEMO:以下の外部Componentのライセンス数は問題ない？
    aggridLicenceKey:
      'Using_this_{AG_Grid}_Enterprise_key_{AG-050661}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Toyotsu_Syscom}_is_granted_a_{Multiple_Applications}_Developer_License_for_{15}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{15_November_2024}____[v3]_[01]_MTczMTYyODgwMDAwMA==c8c0a18b3636f327eee47079f2b25bc0',
    handsontableLicenseKey: '5c519-a234b-b95e5-c423d-4e85b',
    hyperformulaLicenseKey: 'internal-use-in-handsontable',
    googleAnalyticsId: '',
    useGa: false,
    useMockMfaAuth: false, // MFA対応 - trueの場合, MFA設定API(/auth/set-mfa)のresponseはモックデータから取得
  },

  'dins-development-series': {
    projectRegion: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_lfKgSdiLf',
    clientId: 'r6kpppe6cba74snft7igfn9hl',
    apiGateway: 'https://bonsai-development-series.datainsight-dev.toyota-tsusho.com/backend',
    portalApi: 'https://portal-devevelopment-server.datainsight-dev.toyota-tsusho.com',
    portalDomain: 'https://portal-devevelopment-server.datainsight-dev.toyota-tsusho.com', // MFA対応
    redirectSignIn: 'https://bonsai-development-series.datainsight-dev.toyota-tsusho.com',
    redirectSignOut: 'https://bonsai-development-series.datainsight-dev.toyota-tsusho.com',
    cognitoDomain: 'ap-northeast-1lfkgsdilf.auth.ap-northeast-1.amazoncognito.com',
    // MEMO:以下の外部Componentのライセンス数は問題ない？
    aggridLicenceKey:
      'Using_this_{AG_Grid}_Enterprise_key_{AG-050661}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Toyotsu_Syscom}_is_granted_a_{Multiple_Applications}_Developer_License_for_{15}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{15_November_2024}____[v3]_[01]_MTczMTYyODgwMDAwMA==c8c0a18b3636f327eee47079f2b25bc0',
    handsontableLicenseKey: '5c519-a234b-b95e5-c423d-4e85b',
    hyperformulaLicenseKey: 'internal-use-in-handsontable',
    googleAnalyticsId: '',
    useGa: false,
    useMockMfaAuth: false, // MFA対応 - trueの場合, MFA設定API(/auth/set-mfa)のresponseはモックデータから取得
  },

  test: {
    // MEMO : dins環境移行前は staging と同様の設定値にしていたが、staging環境削除に伴い dins-development に合わせています
    projectRegion: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_lfKgSdiLf',
    clientId: 'r6kpppe6cba74snft7igfn9hl',
    apiGateway: 'https://bonsai-development.datainsight-dev.toyota-tsusho.com/backend',
    portalApi: 'https://portal-devevelopment-server.datainsight-dev.toyota-tsusho.com',
    portalDomain: 'https://portal-devevelopment-server.datainsight-dev.toyota-tsusho.com', // MFA対応
    redirectSignIn: 'https://bonsai-development.datainsight-dev.toyota-tsusho.com',
    redirectSignOut: 'https://bonsai-development.datainsight-dev.toyota-tsusho.com',
    cognitoDomain: 'ap-northeast-1lfkgsdilf.auth.ap-northeast-1.amazoncognito.com',
    aggridLicenceKey:
      'Using_this_{AG_Grid}_Enterprise_key_{AG-050661}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Toyotsu_Syscom}_is_granted_a_{Multiple_Applications}_Developer_License_for_{15}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{15_November_2024}____[v3]_[01]_MTczMTYyODgwMDAwMA==c8c0a18b3636f327eee47079f2b25bc0',
    handsontableLicenseKey: '5c519-a234b-b95e5-c423d-4e85b',
    hyperformulaLicenseKey: 'internal-use-in-handsontable',
    googleAnalyticsId: '',
    useGa: true,
    useMockMfaAuth: true, // MFA対応 - trueの場合, MFA設定API(/auth/set-mfa)のresponseはモックデータから取得
  },

  // memo:
  //   本検証環境は、MARSポータルの本番環境を利用します
  //   利用するにあたって、portalApi / userpool / clientId / cognitoDomain は全て本番と同値を利用します
  // todo:
  //   ↑の対応をしたが、MARSポータル側の仕様が最新化されていないため、正常動作せず
  //   一旦、MARSポータルの検証環境を参照するように戻す、どこかのタイミングで再度本番を向くように修正
  'post-staging': {
    projectRegion: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_APA8bvSar',
    clientId: '257h2306r6fvc3lebuoqhoesll',
    apiGateway: 'https://bonsai-post-staging.datainsight-qas.toyota-tsusho.com/backend',
    portalApi: 'https://portal-stg-server.datainsight-qas.toyota-tsusho.com',
    portalDomain: 'https://portal-stg-server.datainsight-qas.toyota-tsusho.com', // MFA対応
    redirectSignIn: 'https://bonsai-post-staging.datainsight-qas.toyota-tsusho.com',
    redirectSignOut: 'https://bonsai-post-staging.datainsight-qas.toyota-tsusho.com',
    cognitoDomain: 'datainsight-pool-stg.auth.ap-northeast-1.amazoncognito.com',
    aggridLicenceKey:
      'Using_this_{AG_Grid}_Enterprise_key_{AG-050661}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Toyotsu_Syscom}_is_granted_a_{Multiple_Applications}_Developer_License_for_{15}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{15_November_2024}____[v3]_[01]_MTczMTYyODgwMDAwMA==c8c0a18b3636f327eee47079f2b25bc0',
    handsontableLicenseKey: '5c519-a234b-b95e5-c423d-4e85b',
    hyperformulaLicenseKey: 'internal-use-in-handsontable',
    googleAnalyticsId: 'G-YDNHYJ3DKH', //bonsai-post-staging
    useGa: true,
    useMockMfaAuth: false, // MFA対応 - trueの場合, MFA設定API(/auth/set-mfa)のresponseはモックデータから取得
  },
  production: {
    // same as prod for fallback
    projectRegion: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_0zpIatPef',
    clientId: '3u7ahfu4gc7a6g32d2v9j484cs',
    apiGateway: 'https://bonsai.datainsight.toyota-tsusho.com/backend',
    portalApi: 'https://portal-server.datainsight.toyota-tsusho.com',
    portalDomain: 'https://portal-server.datainsight.toyota-tsusho.com', // MFA対応
    redirectSignIn: 'https://bonsai.datainsight.toyota-tsusho.com',
    redirectSignOut: 'https://bonsai.datainsight.toyota-tsusho.com',
    cognitoDomain: 'datainsight-pool.auth.ap-northeast-1.amazoncognito.com',
    aggridLicenceKey:
      'Using_this_{AG_Grid}_Enterprise_key_{AG-050661}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Toyotsu_Syscom}_is_granted_a_{Multiple_Applications}_Developer_License_for_{15}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{15_November_2024}____[v3]_[01]_MTczMTYyODgwMDAwMA==c8c0a18b3636f327eee47079f2b25bc0',
    handsontableLicenseKey: '5c519-a234b-b95e5-c423d-4e85b',
    hyperformulaLicenseKey: 'internal-use-in-handsontable',
    googleAnalyticsId: 'G-R63RSZ8GK5', //bonsai-prod
    useGa: true,
    useMockMfaAuth: false, // MFA対応 - trueの場合, MFA設定API(/auth/set-mfa)のresponseはモックデータから取得
  },
};

export const amplifyConfig = {
  aws_project_region: envSettings[currentEnv].projectRegion,
  aws_user_pools_id: envSettings[currentEnv].userPoolId,
  aws_user_pools_web_client_id: envSettings[currentEnv].clientId,
  redirect_sign_in: envSettings[currentEnv].redirectSignIn,
  redirect_sign_out: envSettings[currentEnv].redirectSignOut,
  cognitoDomain: envSettings[currentEnv].cognitoDomain,
};

export const cognitoConfig = {
  userPoolId: envSettings[currentEnv].userPoolId,
  clientId: envSettings[currentEnv].clientId,
};

export const apiGateway = envSettings[currentEnv].apiGateway;
export const portalApi = envSettings[currentEnv].portalApi;
export const portalDomain = envSettings[currentEnv].portalDomain; // MFA対応
export const aggridLicenceKey = envSettings[currentEnv].aggridLicenceKey;
export const handsontableLicenseKey = envSettings[currentEnv].handsontableLicenseKey;
export const hyperformulaLicenseKey = envSettings[currentEnv].hyperformulaLicenseKey;
export const googleAnalyticsId = envSettings[currentEnv].googleAnalyticsId;
export const useGa = envSettings[currentEnv].useGa;
export const useMockMfaAuth = envSettings[currentEnv].useMockMfaAuth; // MFA対応

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 50,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 40,
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};
